module.exports = __webpack_public_path__ + "static/media/Andrew Faix.f0457f3e.png";